export default __webpack_public_path__ + "static/media/Cyberpunk-3.4b4f6e14.gif";